// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';

// Internal Dependencies
import Colours from '../../../../../styles/colours';

const AvailableImage = (props) => (
  <div
    className="position-relative"
    style={{
      cursor:  'pointer',
      border:  `4px solid ${props.src === props.selectedAvailableImage ? Colours.Secondary : 'transparent'}`,
      padding: props.src === props.selectedAvailableImage ? 1 : 0,
    }}
    role="button"
    tabIndex={0}
    onKeyDown={props.onClick}
    onClick={props.onClick}
  >
    <img alt="" src={props.src} width={115} height="auto" />
  </div>
);

AvailableImage.propTypes = {
  src:                    PropTypes.string.isRequired,
  selectedAvailableImage: PropTypes.string.isRequired,
  onClick:                PropTypes.func,
};

AvailableImage.defaultProps = {
  onClick: () => { },
};

export default AvailableImage;
